import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import DropdownList from 'components/controls/DropdownList';
import { Button } from 'antd';
import _notification from 'modules/notification';
import { Card, Table, Modal, Tag, Input, Switch, Radio, Pagination, Checkbox } from 'antd';
import PageHeader from 'components/enterprise/PageHeader';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import EmptyState from 'components/enterprise/EmptyState';
import { routesAdmin } from 'routes/Routes';
import ConfirmPopup from '../popup/ConfirmPopup';
import MyInput from 'components/controls/MyInput';
import { GENERAL_ERROR_MESSAGE, ASSIGN_CENTER_PAGINATION } from 'constants/constants';
import { IMAGE_ASSIGN_TO_CENTER } from '../../constants/Base64Images';
import candidateLogo from "assets/img/candidate.png";
import moment from 'moment';
import CandidateReview from './CandidateReview_new';
import CandidateAssignedList from './CandidateAssignedList_new';
import ButtonComponent from 'components/controls/Button';
import { instance } from '../../modules/ApiRequest';
import { post, timers } from 'jquery';
const { Search } = Input;

let img = new Image();
img.src = IMAGE_ASSIGN_TO_CENTER;
img.width = '50px';

class AssignCenter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: { pageSize: 100, current: 1, total: 0 },
            highlightedRowID: 0,
            data: [],
            category: [],
            degree: [],
            rowData: {},
            loading: false,
            showModel: true,
            showMessageBox: false,
            categoryError: "",
            degreeError: "",
            totalRowCount: 0,
            showCandidateReview: false,
            showCandidateAssignedList: false,
            selectedRowKeys: [],
            searchTerm: "",
            showAll: false,
            txnMatched: "All",

            centerList: [],
            batchList: [],

            postList: [],
            districtList: [],
            talukaList: [],
            stateList: [],

            searchPattern: {
                State: '', StateID: -1,
                District: '', DistrictID: 0,
                Taluka: '', TalukaID: 0,
                Post: '', PostID: 0,
            },

            selectedBatchData: {},
            candidateRemoved: false,
            selectAll: false
        };
    }

    componentDidMount() {
        console.clear();
        //this.getAllCandidates();
        //this.fillFilterDropdown();
        this.fillPost();
        // this.getAllCenters();
        // this.getAllBatches();
    }

    //API operations
    // getAllCandidates = async () => {
    //     try {
    //         this.setState({ loading: true }, async () => {
    //             try {
    //                 let candidateList = await _AdminService.GetAllStudentByCenterAndBatch(this.state.pagination.pageSize);

    //                 console.log("candidateList Data: ", candidateList.data);
    //                 // console.log(this.state.data ? [...new Set(candidateList.data.List.map(item => item.Category ? item.Category : "A"))] : []);

    //                 let searchedData = candidateList.data;

    //                 this.setState({
    //                     ...this.state,
    //                     data: searchedData.List,
    //                     pagination: { ...this.state.pagination, total: searchedData.TotalRecords },
    //                     category: this.state.data ? [...new Set(searchedData.List.map(item => item.Category ? item.Category : "A"))] : [],
    //                     totalRowCount: searchedData.TotalRecords,
    //                     loading: false,
    //                     selectedRowKeys: [],
    //                 });

    //             } catch (e) {
    //                 // TODO
    //                 this.setState({ loading: false });
    //                 console.log('Error: ', e);
    //             }
    //         });
    //     } catch (e) { }
    // }

    // getAllCenters = async () => {
    //     try {
    //         this.setState({ loading: true }, async () => {
    //             try {
    //                 let centerList = await _AdminService.GetAllCenter();
    //                 console.log("centerList Data: ", centerList.data);

    //                 this.setState({
    //                     ...this.state,
    //                     centerList: centerList.data,
    //                     loading: false,
    //                     candidateRemoved: false
    //                 });

    //             } catch (e) {
    //                 // TODO
    //                 this.setState({ loading: false });
    //                 console.log('Error: ', e);
    //             }
    //         });
    //     } catch (e) { }
    // }

    // getAllBatches = async () => {
    //     try {
    //         this.setState({ loading: true }, async () => {
    //             try {
    //                 let batchList = await _AdminService.GetAllClassRoom();
    //                 console.log("batchList Data: ", batchList.data);

    //                 this.setState({
    //                     ...this.state,
    //                     batchList: batchList.data,
    //                     candidateRemoved: false,
    //                     loading: false,
    //                 });

    //             } catch (e) {
    //                 // TODO
    //                 this.setState({ loading: false });
    //                 console.log('Error: ', e);
    //             }
    //         });
    //     } catch (e) { }
    // }

    fillPost = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let postList = await _AdminService.GetAllPost();

                    let postWithoutRollNumbers = postList.data.filter(item => {
                        return item.RollNumbersGenerated == false;
                    })

                    let defaultPost = { Post: '', PostID: 0 };

                    this.setState({
                        ...this.state,
                        postList: postWithoutRollNumbers,
                        searchPattern: { ...this.state.searchPattern, ...defaultPost },
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    fillCenterBatch = async () => {
        try {
            if (this.state.searchPattern.PostID == 0)
                return;

            this.setState({ loading: true }, async () => {
                try {
                    let centerList = await _AdminService.GetAllCenter(this.state.searchPattern.PostID);
                    let batchList = await _AdminService.GetAllClassRoom();
                    //console.log("batchList Data: ", batchList.data);

                    this.setState({
                        ...this.state,
                        centerList: centerList.data,
                        batchList: batchList.data,
                        candidateRemoved: false,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }


    fillFilterDropdown = async (postID) => {
        try {
            let districtsList = await _AdminService.GetAllDistricts(postID);
            let talukasList = await _AdminService.GetAllTalukas(postID);
            let statesList = await _AdminService.GetAllStates(postID);

            this.setState({
                ...this.state,
                districtList: districtsList.data,
                talukaList: talukasList.data,
                stateList: statesList.data,
            });
        } catch (e) {
            // TODO
            this.setState({ loading: false });
            console.log('Error: ', e);
        }

        // try {
        //     this.setState({ loading: true }, async () => {
        //         try {
        //             //let postList = await _AdminService.GetAllPost();
        //             let districtsList = await _AdminService.GetAllDistricts(postID);
        //             let talukasList = await _AdminService.GetAllTalukas(postID);
        //             let statesList = await _AdminService.GetAllStates(postID);

        //             this.setState({
        //                 ...this.state,
        //                 //postList: postWithoutRollNumbers,
        //                 districtList: districtsList.data,
        //                 talukaList: talukasList.data,
        //                 stateList: statesList.data,
        //                 //searchPattern: { ...this.state.searchPattern, ...defaultPost },
        //                 loading: false,
        //             });

        //             //this.search();

        //         } catch (e) {
        //             // TODO
        //             this.setState({ loading: false });
        //             console.log('Error: ', e);
        //         }
        //     });
        // } catch (e) { }
    }

    search = async () => {
        try {
            //console.log(this.state.searchTerm, 'pagination: ', this.state.pagination);

            this.setState({ loading: true }, async () => {
                try {

                    const params = {
                        State: this.state.searchPattern.State,
                        District: this.state.searchPattern.District,
                        Taluka: this.state.searchPattern.Taluka,
                        Post: this.state.searchPattern.Post,
                    }

                    //console.log("Search params ", params);

                    let candidateList = await _AdminService.GetAllStudentByCenterAndBatch(this.state.pagination.pageSize, this.state.pagination.current, this.state.searchTerm, params);

                    let searchedData = candidateList.data;

                    // console.log("searched Data: ", searchedData);
                    // console.log(this.state.data ? [...new Set(searchedData.List.map(item => item.Category ? item.Category : "A"))] : []);

                    this.setState({
                        ...this.state,
                        data: searchedData.List,
                        pagination: { ...this.state.pagination, total: searchedData.TotalRecords },
                        totalRowCount: searchedData.TotalRecords,
                        loading: false,
                        selectedRowKeys: [],
                        selectAll: false
                    });

                    this.fillCenterBatch();
                    this.uncheckSelectedRows();

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    onBulkApproveReject = async (flag) => {
        try {

            if (this.state.selectedRowKeys.length == 0) {
                _notification.showMessage('error', "Please select at least one candidate.");
                return;
            }

            //console.log(this.state.searchTerm, 'pagination: ', this.state.pagination);
            this.setState({ loading: true }, async () => {
                try {

                    const params = {
                        ApplicationIds: this.state.selectedRowKeys,
                        IsApprovedRejectedStatus: flag == 1 ? true : false
                    }

                    const response = await _AdminService.UpdateBulkApprovedOrRejectedStatus(params);

                    if (response.status == 200) {
                        _notification.showMessage('success', `Bulk Forms ${flag == 1 ? "Approved" : "Rejected"} successfully.`);
                        this.setState({
                            post: "",
                            postError: "",
                            showModel: false,
                            loading: false,
                            highlightedRowID: params.Id
                        });
                        this.search();
                    }
                    else {
                        _notification.showMessage('error', response.data.message);
                    }

                    //this.search();//Calling this to refresh current page
                    //
                    this.setState({
                        loading: false,
                        selectedRowKeys: [],
                        selectAll: false
                    });
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    onClearSearch = (value) => {
        this.setState({
            // ...this.state,
            data: [],
            pagination: { ...this.state.pagination, current: 1, total: 0 },
            totalRowCount: 0,
            selectedRowKeys: [],
            selectAll: false,
            centerList: [],
            batchList: [],
            districtList: [],
            talukaList: [],
            stateList: [],
            candidateRemoved: false,
            searchTerm: '',
            searchPattern: {
                State: '',
                StateID: -1,
                District: '',
                DistrictID: 0,
                Taluka: '',
                TalukaID: 0,
                Post: '',
                PostID: 0,
            }
        }, () => {
            this.search();            
        });
    }


    onDropdownChange = (event) => {
        //console.log(event.target.options[event.target.selectedIndex].text, event.target.selectedIndex);
        let text = event.target.options[event.target.selectedIndex].text;
        let name = '';
        if (event.target.name == "Post") {
            name = 'PostID';
            text = event.target.value;
        }
        else if (event.target.name == "State")
            name = 'StateID';
        else if (event.target.name == "District")
            name = 'DistrictID';
        else if (event.target.name == "Taluka")
            name = 'TalukaID';


        this.setState({
            ...this.state,
            searchPattern: { ...this.state.searchPattern, [name]: event.target.value, [event.target.name]: event.target.selectedIndex <= 0 ? "" : text }
        });

        if (event.target.name == 'Post' && event.target.value > 0) {
            //console.log("in if");
            this.fillFilterDropdown(event.target.value);
            this.search();
        }

        if (event.target.name == 'Post' && event.target.value == 0) {
            //console.log("in other if");
            this.clearGrid();
        }
    }

    clearGrid = () => {
        this.setState({
            ...this.state,
            data: [],
            pagination: { pageSize: 500, current: 1, total: 0 },
            totalRowCount: 0,
            selectedRowKeys: [],
            selectAll: false,
            centerList: [],
            batchList: [],
            districtList: [],
            talukaList: [],
            stateList: [],
            candidateRemoved: false,
            searchTerm: '',
            searchPattern: {
                State: '', StateID: -1,
                District: '', DistrictID: 0,
                Taluka: '', TalukaID: 0,
                Post: '', PostID: 0,
            }
        });
    }

    handleKeyDown = (event) => {
        console.log(event.key);
        if (event.key == "Enter") {
            this.search();
        }
    }

    onSearch = (value) => {
        //console.log("Searched: ", value);
        this.setState({ searchTerm: value, pagination: { ...this.state.pagination, current: 1 }, });
        this.search();
    }

    onAllChange = (checked) => {
        this.setState({ showAll: checked, pagination: { ...this.state.pagination, current: 1, pageSize: checked ? 999999 : 6 }, });
        this.search();
    }

    onTxnMatchUnmatchChange = (value) => {
        //console.log(value.target.value);
        this.setState({ txnMatched: value.target.value });
        this.search();
    }

    onApproveRejectChange = (value) => {
        this.search();//Calling this to refresh current page
    }

    closeReviewModal(value = false) {
        this.setState({ showMessageBox: value, showCandidateReview: false });
    }

    closeCandidateAssignedModel(value = false) {
        this.setState({ showMessageBox: value, showCandidateAssignedList: false });
        if (this.state.candidateRemoved) {
            // this.getAllCenters();
            // this.getAllBatches();
            //this.fillCenterBatch();
            this.search();
        }
    }

    onSearchTextChange = ({ target: { name, value } }) => {
        this.setState({
            ...this.state,
            searchTerm: value
        });
    }

    // Html table events
    onHtmlEditClick = record => {
        //console.log(record);
    }

    onPageChange = (pageNumber) => {
        //console.log(pageNumber);
        this.setState({ pagination: { ...this.state.pagination, current: pageNumber }, });
        this.search();
    }

    onShowSizeChange = (current, pageSize) => {
        //console.log(current, pageSize);
        this.setState({ pagination: { ...this.state.pagination, current: 1, pageSize: pageSize }, });
        this.search();
    };

    onHtmlEditClick = (value) => {
        //console.log('params ', value);
        this.setState({ rowData: value, showModel: true, highlightedRowID: 0, showCandidateReview: true });
    };

    onHtmlSelectRow = studentID => {
        //console.log(studentID);
        let tempKeys = this.state.selectedRowKeys;
        if (tempKeys.includes(studentID)) {
            this.setState({ selectedRowKeys: tempKeys.filter((value) => value != studentID) });
        }
        else {
            tempKeys.push(studentID);
            this.setState({ selectedRowKeys: tempKeys });
        }
    }

    onHtmlSelectAll = (e) => {

        console.log('value of checkbox : ', e.target.checked);

        //this.setState({ selectedRowKeys: this.state.data.map(a => a.Id) });
        var myTable = document.getElementById('myTable');
        let cbox = myTable.querySelectorAll("input[type='checkbox']");

        for (var i = 1; i < cbox.length; i++) {
            cbox[i].checked = e.target.checked;
        }

        if (e.target.checked) {
            this.setState({ selectedRowKeys: this.state.data.map(a => a.Id), selectAll: !this.state.selectAll });
        }
        else {
            this.setState({ selectedRowKeys: [], selectAll: !this.state.selectAll });
        }

    }

    uncheckSelectedRows=()=>{
        //this.setState({ selectedRowKeys: this.state.data.map(a => a.Id) });
        var myTable = document.getElementById('myTable');
        let cbox = myTable.querySelectorAll("input[type='checkbox']");

        for (var i = 1; i < cbox.length; i++) {
            cbox[i].checked = false;
        }
    }

    // On Card click event
    onCenterCardClick = (item) => {
        //console.log("Drop...", item)


        if (this.state.selectedRowKeys.length == 0) {
            this.setState({ showCandidateAssignedList: true, selectedBatchData: item });
        }

        if (this.state.selectedRowKeys.length == 0)
            return;

        const params = {
            StudentIds: this.state.selectedRowKeys,
            Center_Id: item.Center_Id,
            ClassRoom_Id: item.Id,
        }

        //console.log("Final data: ", params);

        try {
            this.setState({ loading: true }, async () => {
                try {
                    const response = await _AdminService.UpdateStudentCenterAndBatch(params);
                    //console.log("Post response: ", response);
                    if (response.status == 200) {
                        _notification.showMessage('success', "Center and Batch assigned successfully.");
                        this.setState({
                            loading: false,
                            selectedRowKeys: [],
                        });
                        // this.getAllCandidates();
                        // this.getAllCenters();
                        // this.getAllBatches();
                        this.search();
                    }
                    else {
                        _notification.showMessage('error', response.data.message);
                    }
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                }
            });
        } catch (e) { }


    }

    handleDrag(count, e) {
        console.log("Dragging...", e)
        if (count == 0) {
            e.preventDefault();
            return;
        }
        e.dataTransfer.setDragImage(img, 0, 0);
    }

    allowDrop(even) {
        even.preventDefault();
    }

    handleDrop(item, ee) {
        //console.log("Drop...", item, ee)
        document.getElementById("batch_" + item.Id).style.backgroundColor = "";
        document.getElementById("batch_" + item.Id).style.transform = "";

        if (this.state.selectedRowKeys.length == 0)
            return;

        const params = {
            StudentIds: this.state.selectedRowKeys,
            Center_Id: item.Center_Id,
            ClassRoom_Id: item.Id,
        }

        //console.log("Final data: ", params);

        try {
            this.setState({ loading: true }, async () => {
                try {
                    const response = await _AdminService.UpdateStudentCenterAndBatch(params);
                    //console.log("Post response: ", response);
                    if (response.status == 200) {
                        _notification.showMessage('success', "Center and Batch assigned successfully.");
                        this.setState({
                            loading: false,
                            selectedRowKeys: [],
                            selectAll: false
                        });
                        // this.getAllCandidates();
                        // this.getAllCenters();
                        // this.getAllBatches();
                        this.search();
                    }
                    else {
                        _notification.showMessage('error', response.data.message);
                    }
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                }
            });
        } catch (e) { }

    }

    // On drag hover and leave effect
    onDragEnter = (eve, e) => {
        e.preventDefault();
        document.getElementById(eve).style.backgroundColor = "#ebde34";
        document.getElementById(eve).style.transition = "0.5s";
        document.getElementById(eve).style.transform = "scale(1.05)";
    }

    onDragLeave = (eve, e) => {
        e.preventDefault();
        //console.log("leave");
        document.getElementById(eve).style.backgroundColor = "";
        document.getElementById(eve).style.transform = "";
    }
    candidateRemoved = () => {
        this.setState({ candidateRemoved: true });
    }

    render() {
        const candidateReviewPopup = (<Modal
            centered={true}
            width={950}
            bodyStyle={{
                height: "550px",
                padding: 50,
                paddingTop: 20,
                alignItems: "center",
                justifyContent: "center",
                //display: " flex"
            }}
            className="modelPopAnt"
            visible={this.state.showCandidateReview}
            onCancel={() => this.closeReviewModal(false)}
            footer={false}
        >
            <CandidateReview
                onCancel={() => this.closeReviewModal(false)}
                onStateChange={this.onApproveRejectChange}
                popupData={this.state.rowData}
                message="Are you sure, you want to delete this post?"
            />
        </Modal>);

        const candidateAssignedListPopup = (<Modal
            centered={true}
            width={1200}
            // bodyStyle={{
            //     height: "560px",
            //     padding: 10,
            //     paddingTop: 40,
            //     alignItems: "center",
            //     justifyContent: "center",
            //     //display: " flex"
            // }}
            className="modelPopAnt"
            visible={this.state.showCandidateAssignedList}
            onCancel={() => this.closeCandidateAssignedModel(false)}
            footer={false}
        >
            <CandidateAssignedList
                onCancel={() => this.closeCandidateAssignedModel(false)}
                //onStateChange={this.onApproveRejectChange}
                popupData={this.state.selectedBatchData}
                onCandidateDeallocation={this.candidateRemoved}
                message="Are you sure, you want to delete this post?"
            />
        </Modal>);

        // if (this.state.loading)
        //     return <Spin size="large" />

        return (
            <div className="py-3 assign-center">
                <PageHeader
                    title="Assign Center"
                    breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Candidates' }, { label: 'Assign Center' }]}
                />
                {this.state.loading && <LoadingSpinner />}
                <div style={{ display: 'flex' }}>
                    <div className='gridViewSection'>
                        <div className="ent-panel mb-3">
                        <div className='table-top mb-3' style={{ display: 'flex', height: '40px', paddingLeft: '7px', alignSelf: 'center', visibility: this.state.loading ? "hidden" : "visible" }}>
                            <DropdownList style={{ marginLeft: "50px" }}
                                value={this.state.searchPattern.PostID}
                                name="Post"
                                onChange={this.onDropdownChange}
                                onKeyDown={this.handleKeyDown}
                                placeholder="Select Post/Exam"
                                isRequired={false}
                                options={this.state.postList}
                            />

                            <Search
                                placeholder="Search Form No., Name, Post, Phone, Category, District, State, Taluka"
                                allowClear
                                onSearch={this.search}
                                value={this.state.searchTerm}
                                onChange={this.onSearchTextChange}
                                style={{
                                    width: 200,
                                    //paddingLeft: '7px'
                                }}
                            />

                            <DropdownList style={{ marginLeft: "50px" }}
                                value={this.state.searchPattern.StateID}
                                name="State"
                                onChange={this.onDropdownChange}
                                onKeyDown={this.handleKeyDown}
                                placeholder="Select State"
                                isRequired={false}
                                options={this.state.stateList}
                            />
                            <DropdownList style={{ marginLeft: "50px" }}
                                value={this.state.searchPattern.DistrictID}
                                name="District"
                                onChange={this.onDropdownChange}
                                onKeyDown={this.handleKeyDown}
                                placeholder="Select District"
                                isRequired={false}
                                options={this.state.districtList}
                            />
                            <DropdownList style={{ marginLeft: "50px" }}
                                value={this.state.searchPattern.TalukaID}
                                name="Taluka"
                                onChange={this.onDropdownChange}
                                onKeyDown={this.handleKeyDown}
                                placeholder="Select Taluka"
                                isRequired={false}
                                options={this.state.talukaList}
                            />
                            <Button shape="circle" icon="search" aria-label="Search" className="button-global circle" onClick={this.search} style={{ marginLeft: "10px", alignSelf: 'center' }} />
                            <Button shape="circle" icon="reload" aria-label="Clear search" className="button-global circle"  onClick={this.onClearSearch} style={{ marginLeft: "10px", alignSelf: 'center' }} />
                        </div>
                        </div>

                        <div className=" analysisWrap customTableDivWrapper admin-custom-table" >
                            <div className="custom-table-wrap  admin-table table-striped-rows mb-3"> 
                                <div className=" analysisWrap ant-table-small" >
                                    <div className="ant-table-content">
                                        <div className="ant-table-body">
                                            <table className='customTable table-striped-rows whiteBg' id="myTable">
                                            <thead className="ant-table-thead">
                                                <tr className='stickyDiv'>
                                                    <th style={{ width: '2%' }}><input type="checkbox" checked={this.state.selectAll} className='customTableAllCheckbox' onClick={this.onHtmlSelectAll.bind(this)} /></th>
                                                    <th style={{ width: '7%' }}>Form #</th>
                                                    <th style={{ width: '22%' }}>Name</th>
                                                    <th style={{ width: '10%' }}>Applied Post</th>
                                                    <th style={{ width: '5%' }}>Gender Age</th>
                                                    <th style={{ width: '7%' }}>State</th>
                                                    <th style={{ width: '7%' }}>District</th>
                                                    <th style={{ width: '7%' }}>Taluka</th>
                                                    {/* <th style={{ width: '7%' }}>Action</th> */}
                                                </tr>
                                            </thead>
                                            <tbody className='ant-table-tbody '>
                                                
                                                {this.state.data.map((item, index) => (

                                                    <tr data-index={index} key={item.Id} draggable>
                                                        <td><input type="checkbox" className='customTableCellCheckbox' onClick={(enent) => this.onHtmlSelectRow(item.Id)} /></td>
                                                        <td>{item.Form_Number}</td>
                                                        <td>{item.First_Name + ' ' + item.Middle_Name + ' ' + item.Last_Name}</td>
                                                        <td>{item.Applied_Post}</td>
                                                        <td><label style={{ fontSize: '13px', textAlign: 'left', alignContent: 'center', marginTop: '5px', lineHeight: '15px' }}>{item.Gender} <br />  {moment().diff(item.Birth_Date, 'years')} yrs</label></td>
                                                        <td>{item.State}</td>
                                                        <td>{item.District}</td>
                                                        <td>{item.Taluka}</td>

                                                    </tr>
                                                    ))}
    
                                                    
                                            </tbody>
    
                                        </table>
                                        
                                        {!this.state.data.length ?
                                            <EmptyState icon="inbox" title="No Records Found" description="No candidates match the current search or filter criteria." />
                                            : ""}
                                        </div>
                                        <div className="ant-table-footer ">
                                            <div className="d-flex align-items-center justify-content-end">
                                                {this.state.selectedRowKeys.length ?
                                                <label style={{  marginRight: '20px', color: 'darkgreen' }}>Selected Records: {this.state.selectedRowKeys.length}</label>
                                                : <></>}
                                                <label style={{  marginRight: '20px' }}>Total Records: {this.state.totalRowCount}</label>        
                                            </div>        
                                        </div>
                                    </div>
                                    
                                </div>
                                 <Pagination
                                    showSizeChanger
                                    pageSizeOptions= {ASSIGN_CENTER_PAGINATION}
                                    onShowSizeChange={this.onShowSizeChange}
                                    onChange={this.onPageChange}
                                    defaultCurrent={this.state.pagination.current}
                                    total={this.state.pagination.total}
                                    pageSize={this.state.pagination.pageSize}
                                    className="ant-table-pagination mini"
                                />   
                            </div>
                           
                        </div>
                    </div>

                    <div className='centerBatchViewSection' style={{ backgroundColor: 'white', marginTop: '43px' }}>
                        <div className=" analysisWrap analysisWrap ent-panel h-100" >
                            <div className='centerDiv overflow-hidden admin-inner-wrap p-2 h-100'>
                                {(this.state.searchPattern.PostID && this.state.centerList.length == 0) ?
                                    <div className='text-center h-100 mt-5 w-100' bordered="true">
                                        <h5 className='m-5 text-info'>No Center and Batches</h5>
                                    </div> : <></>
                                }
                                {(!this.state.searchPattern.PostID && this.state.centerList.length == 0) ?
                                    <div className='text-center h-100 mt-5 w-100' bordered="true">
                                        <h5 className='m-5 text-info'>Select Exam/Post to view Center & Batches</h5>
                                    </div> : <></>
                                }
                                {this.state.centerList.map((item, index) => (
                                    <>
                                        <div className='centerDivParentDiv'>
                                            <div key={index} bordered="true">
                                                <div style={{ width: '100%' }}>
                                                    <label style={{ textAlign: 'start', marginTop: '5px', fontSize: '14px' }}>{item.Name}</label>
                                                    <div>
                                                        <label style={{ float: 'left', marginTop: '-7px' }}>{item.Description}</label>
                                                        <label style={{ float: 'right', color: 'green', fontWeight: 'bold', fontSize: '14px', marginRight: '7px', marginTop: '-7px' }}>Total: {item.AssignedCount}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {this.state.batchList.filter(tag => tag.Center_Id === item.Id).map((item, index) => (
                                            <div key={index} className='centerDivBatchDiv' id={"batch_" + item.Id} onDragOver={(eve) => this.onDragEnter("batch_" + item.Id, eve)}
                                                onDragLeave={(eve) => this.onDragLeave("batch_" + item.Id, eve)}>
                                                <div key={index} bordered="true" style={{ width: '275px', height: '40px' }} onClick={(e) => this.onCenterCardClick(item)} onDrop={(event) => this.handleDrop(item, event)} onDragOver={this.allowDrop}>
                                                    <table style={{ width: '275px', height: '40px', marginLeft: '10px' }}>
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan={2}>
                                                                    <label style={{ textAlign: 'start', marginTop: '2px', fontSize: '14px' }}>{item.Name}</label>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td> <label style={{ float: 'left', fontSize: '11px', marginTop: '-13px' }}>{moment(item.Exam_Date).isValid() ? moment(item.Exam_Date).format('DD-MMM-YY') : ""} - {item.Exam_Time}</label></td>
                                                                <td>
                                                                    <label style={{ float: 'right', fontWeight: 'bold', fontSize: '13px', marginRight: '15px', marginTop: '-15px' }}>{item.AssignedCount}
                                                                        <img height={12} width={12} src={candidateLogo} style={{ marginTop: '-3px' }}></img>
                                                                    </label>

                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.showCandidateReview ? candidateReviewPopup : <></>}
                {this.state.showCandidateAssignedList ? candidateAssignedListPopup : <></>}
            </div >)



    };
}

export default AssignCenter;